import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'convertFormValueToReadOnlyDisplay',
  standalone: true
})
export class ConvertFormValueToReadOnlyDisplayPipe implements PipeTransform {

  transform(value: string | number | string[] | number[] | null | undefined) {
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    return value;
  }
}
